import { render } from "./PassBlockingTable.vue?vue&type=template&id=53c22127"
import script from "./PassBlockingTable.vue?vue&type=script&lang=js"
export * from "./PassBlockingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__